export default "__VITE_ASSET__Czb2zm2N__"